<template>
  <div class="lottie-container" v-lottie></div>
</template>

<script>
import lottie from 'lottie-web';

export default {
  props: { animationData: Object },
  directives: {
    lottie: {
      inserted(el, _, { context }) {
        lottie
          .loadAnimation({
            container: el,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: context.animationData,
          })
          .addEventListener('data_ready', () => {
            context.$emit('updated');
          });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.lottie-container {
  width: 180px;
  height: 180px;
  margin: auto;
}
</style>
